{
  "back": "Back",
  "share": "Share",
  "watchVideo": "Watch Video",
  "notFoundTitle": "Sermon Not Found",
  "notFoundDescription": "We couldn't find that sermon."
}
